<template>
    <ae-container>
        <template slot="top-left">
            <div class="wr-picture">
                <router-link
                        :to="profileLink"
                        v-b-tooltip.hover
                        :title="fullName"
                >
                    <b-img
                            :src="profilePicture"
                            alt="Votre avatar"
                            height="30px"
                            width="30px"
                            fluid
                    />
                </router-link>
            </div>
            <div class="wr-top-left-infos">
                <p>
                    <i class="far fa-bell"></i>
                    Notifications: <span>{{notifications}}</span>
                </p>
                <p>
                    <i class="far fa-star"></i>
                    Nombres de participations: <span>{{home.stats.reservations}}</span>
                </p>
                <p>
                    <i class="fas fa-users"></i>
                    Mon réseau: <span>{{home.stats.friends}}</span>
                </p>
            </div>
        </template>
        <template slot="middle-left">
            <home-middle-news
                    v-if="home.news.length > 0"
                    :element="home.news[0]"
                    class="br-3"
            />
            <home-placeholder
                    v-if="home.news.length === 0"
                    target="meetings"
                    class="br-3"
            />
        </template>
        <template slot="bottom-left">
            <home-placeholder
                    target="communities"
            />
        </template>
        <template slot="center">
            <div class="pt-1 mb-2">
                <b-card
                        class="relais--card py-3"
                        :class="{'br-4 block--shadow border-0 wr-header': isDesktop}"
                >
                    <header class="relais--header pb-0">
                        <h1 class="relais--title pb-1">
                            <i class="fas fa-child"></i>
                            Bienvenue {{user.firstname}},
                        </h1>
                        <div class="row no-gutters relais--info">
                            <div class="col-1 px-0">
                                <i class="fas fa-info-circle"></i>
                            </div>
                            <div class="col-11 px-0">
                                <p class="mb-0">
                                    Retrouvez ici vos activités et prochaines séances ainsi que les
                                    dernières nouvelles de votre réseau.
                                </p>
                            </div>
                        </div>
                    </header>
                </b-card>
            </div>
            <ae-block
                    :properties="['scroll-x']"
                    class="py-2 home--block br-4 bg-whitesmoke"
                    style="margin-top: 3px"
            >
                <home-top-worker
                        class="mx-1"
                        v-for="(action, index) of home.top"
                        :key="`home-actionBar-action-${index}`"
                        :action="action"
                />
                <!-- Dummy div pour avoir un padding en fin de scroll -->
                <div style="min-width: 2%!important;min-height:100%!important;visibility: hidden;"/>
            </ae-block>
            <ae-block
                    class="mt-2 bg-whitesmoke h-100 p-2"
            >
                <h5
                        v-if="home.meetings.length > 0"
                        class="text-center text-primary mt-2"
                >
                    <b><i class="fas fa-child"/> Rejoindre une activité dans mon entreprise</b>
                </h5>
                <meeting-by-day-list
                        :meetings="home.meetings"
                />
                <home-placeholder
                        v-if="home.meetings.length === 0"
                        target="meetings"
                />
            </ae-block>
        </template>
        <template slot="top-right">
            <h2 class="mt-1"><b>Mon réseau, mes collègues</b></h2>
            <social-create-post-comment
                    typeObject="post"
                    typePost="post"
                    @publish="onPost($event)"
                    moodable
                    roleable
                    mode="light"
                    class="m-1"
            />
        </template>
        <template slot="bottom-right">
            <timeline-container
                    class="br-3"
                    :elements="actuality(4)"
                    :bordered="true"
                    @update="update()"
                    @refresh="update()"
                    :key="`home-desktop-timeline`"
            />
            <home-placeholder
                    v-if="actuality(1).length === 0"
                    target="post"
            />
        </template>
    </ae-container>
</template>

<script>
    import AeContainer from "../../Container";
    import {APP_API_URL} from '@/utils/types/setting'
    import HomeBottomMeeting from "../bottom/Meeting";
    import HomePlaceholder from "../Placeholder";
    import SocialCreatePostComment from "../../SocialCreatePostComment";
    import TimelineContainer from "../../TimelineContainer";
    import HomeTopWorker from "../top/Worker";
    import AeBlock from "../../Block";
    import HomeMiddleNews from "../middle/News";
    import MeetingByDayList from "../../meeting/ByDay/List";

    export default {
        name: 'home-desktop-worker',
        components: {
            MeetingByDayList,
            HomeMiddleNews,
            AeBlock,
            HomeTopWorker,
            TimelineContainer, SocialCreatePostComment, HomePlaceholder, HomeBottomMeeting, AeContainer
        },
        data: () => ({
            APP_API_URL,
            apiOrigin: null,
            isDesktop: window.innerWidth > 768
        }),
        async mounted() {
            const {origin} = new URL(this.$store.state.base.setting[APP_API_URL])
            this.apiOrigin = origin
        },
        methods: {
            async update() {
                await this.$store.dispatch('base/appInterface/home')
            },
            actuality(limit) {
                return this.home.timeline.filter((t) => {
                    return t.type === 'actuality'
                }).splice(0, limit).map((t) => {
                    return t.element
                })
            },
            reminders(limit) {
                return this.home.timeline.filter((t) => {
                    return t.type === 'coach_todo'
                }).splice(0, limit).map((t) => {
                    return t.element
                })
            },
            async onPost(postComment) {
                await this.$store.dispatch('base/timeline/load', {limit: 4, offset: 0})
            }
        },
        computed: {
            notifications() {
                return this.$store.state.base.notification.count
            },
            home() {
                return this.$store.state.base.appInterface.home
            },
            user() {
                return this.$store.state.base.account.information
            },
            hasRoleWorker() {
                return this.$store.getters['base/account/getIsWorker'](this.user)
            },
            hasRoleCoach() {
                if (!this.user) return false
                return this.$store.getters['base/account/getIsCoach'](this.user)
            },
            hasRoleRelais() {
                return this.$store.getters['base/account/getIsWorkerRelais'](this.user)
            },
            hasRoleReferent() {
                return this.$store.getters['base/account/getIsCoachReferent'](this.user)
            },
            profileLink() {
                return this.hasRoleWorker ? {
                    name: 'profile',
                    params: {id: this.user.id}
                } : {
                    name: 'account-settings'
                }
            },
            folder() {
                return `/static/img/icons/navbar/${this.iconsColor}/`
            },
            color() {
                let color = 'bleu'
                if (
                    this.interface &&
                    this.interface.colors &&
                    this.interface.colors.navbar &&
                    this.interface.colors.navbar['icon-color']
                ) color = this.interface.colors.navbar['icon-color']
                return color
            },
            iconsColor() {
                const color = this.color
                switch (color) {
                    case 'bleu':
                        return 'blue'
                    case 'noir':
                        return 'black'
                    case 'blanc':
                    default:
                        return 'white'
                }
            },
            fullName() {
                return this.$store.getters['base/account/getFullName'](this.user)
            },
            profilePicture() {
                return this.$store.getters['base/account/getAvatar'](this.user) !== '/static/img/icons/user.png' ?
                    this.$store.getters['base/account/getAvatar'](this.user) : `${this.folder}profile.png`
            },
        }
    }
</script>
